module.exports = __webpack_public_path__ + "img/gallery1.948900cd.jpg";